/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedeemNftRewardBody
 */
export interface RedeemNftRewardBody {
    /**
     * 
     * @type {string}
     * @memberof RedeemNftRewardBody
     */
    transactionHash?: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemNftRewardBody
     */
    nftOwnershipId: string;
}

export function RedeemNftRewardBodyFromJSON(json: any): RedeemNftRewardBody {
    return RedeemNftRewardBodyFromJSONTyped(json, false);
}

export function RedeemNftRewardBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedeemNftRewardBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionHash': !exists(json, 'transactionHash') ? undefined : json['transactionHash'],
        'nftOwnershipId': json['nftOwnershipId'],
    };
}

export function RedeemNftRewardBodyToJSON(value?: RedeemNftRewardBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactionHash': value.transactionHash,
        'nftOwnershipId': value.nftOwnershipId,
    };
}


